'use strict';

const dialog = require('../../dialog'),
    scrollHelper = require('../../modules/helpers/scroll'),
    mobileImageHolder = $('.js-mobile-image-holder');

function initEvents(){
    $(document).on('click', '.js-giftset-replace-accept', replaceGiftSet);

    $(document).on('click.popup', '.js-modal-overlay', function(){
        dialog.close();
    });

    $(document).on('click touchstart', '.js-giftset-replace-close', '.js-modal-overlay', function(){
        dialog.close();
    });

    giftSetToggle();
}

function giftSetToggle() {
    const $pgSetWrapper = '.js-pgset-container';

    $(document).off('click.pgsetexpand').on('click.pgsetexpand', '.js-expand-pgset', function (e) {
        e.preventDefault();
        const $this = $(this);
        const container = $this.closest('.js-cart-row').next().find($pgSetWrapper);
        $this.toggleClass('expanded');
        container.stop().slideToggle(500, function () {
            container.attr('aria-hidden', !$this.hasClass('expanded'));
        });
    });

}

function replaceGiftSet() {
    $('.js-add-to-cart').click();
    dialog.close();
}

/**
 * @description show replacing gift set choices popup
 */
function showReplacePGDialog() {
    dialog.open({
        target: $('#giftset-replace-dialog'),
        options: {
            dialogClass: 'popup-generic-holder',
            width: 600,
            open: function() {
                $('.js-modal-overlay').show();
                scrollHelper.disableScrollEventsOnEl('.js-modal-overlay, .js-giftset-replace-dialog-wrapper, .ui-dialog-titlebar-close');
                $('input[name="showReplacePGPopup"]').val('false');
            },
            close: function(){
                dialog.close();
                scrollHelper.enableScrollEventsOnEl('.js-modal-overlay, .js-giftset-replace-dialog-wrapper, .ui-dialog-titlebar-close');
                $('.js-modal-overlay').hide();
                $('input[name="showReplacePGPopup"]').val('true');
            }
        }
    });
}

function handleMobileMinicartImage(form, response){
    const finalProductId = $('input[name="finalProductID"]', form);
    if (!finalProductId.length || !finalProductId.val()) {
        return;
    }
    const image = $('[data-finalset-image="' + finalProductId.val() + '"]', response);
    if (!image.length) {
        return;
    }
    mobileImageHolder.html(image);
}

const pgCartUtils = {
    init: initEvents,
    showReplacePGDialog: showReplacePGDialog,
    handleMobileMinicartImage: handleMobileMinicartImage
};

module.exports = pgCartUtils;
